/**
 * Shared error banner for a failed page-level load (paired with
 * useLoadState.ts). `role="alert"` so it is reliably announced and
 * queryable in tests -- the styling used to drift page to page (some had
 * `role="alert"` and `mt: 2`, others neither and `mb: 2`); this is the one
 * normalized version.
 */
import Alert from '@mui/material/Alert';

export interface LoadErrorAlertProps {
  message: string;
}

export function LoadErrorAlert({ message }: Readonly<LoadErrorAlertProps>): React.JSX.Element {
  return (
    <Alert role="alert" severity="error" sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}

export default LoadErrorAlert;
